/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_ContractInputs */

const en_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

const ar_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#عقد`)
};

const bn_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

const de_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

const es_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

const fr_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

const pt_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

const zh_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

const tr_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

const ru_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

const pl_svtag_contract = /** @type {(inputs: Svtag_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#CONTRACT`)
};

/**
* | output |
* | --- |
* | "#CONTRACT" |
*
* @param {Svtag_ContractInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_contract = /** @type {((inputs?: Svtag_ContractInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_ContractInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_contract(inputs)
	if (locale === "bn") return bn_svtag_contract(inputs)
	if (locale === "de") return de_svtag_contract(inputs)
	if (locale === "es") return es_svtag_contract(inputs)
	if (locale === "fr") return fr_svtag_contract(inputs)
	if (locale === "pt") return pt_svtag_contract(inputs)
	if (locale === "zh") return zh_svtag_contract(inputs)
	if (locale === "tr") return tr_svtag_contract(inputs)
	if (locale === "ru") return ru_svtag_contract(inputs)
	if (locale === "pl") return pl_svtag_contract(inputs)
	return en_svtag_contract(inputs)
});